import Modal from './modal';
import getLayout from './get-modal-layout';

const classNames = {
  footer: {
    static: `page-footer--static`
  }
};

class ModalMezzanine extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelector(`.js-gallery-mezzanine`);
    this.footer = this.page.querySelector(`.page-footer`);
    this.plan = ``;
    this.lang = document.querySelector(`body`).dataset.lang;
    this.current_mezzanine = this.lang !== 'ru' ? `mezzanine_${this.lang}` : 'mezzanine';
  };

  init({[this.current_mezzanine]: plan}) {
    super.createModal();
    this.plan = plan;
    this.createModalWrap();
    this.bindHandlers();
  };

  createModalWrap() {
    super.addLayout(getLayout(`mezzanine`));
    this.createPlan();
  };

  createPlan() {
    const wrap = this.page.querySelector(`#house-mezzanine`);
    const content = document.createElement(`div`);
    const planLayout = () => {
      return `<div class="modal-floors__floor">
                <img src="${this.plan}" alt="План мезонина">
              </div>`
    };

    content.className = `modal-floors__slider modal-slider`;
    content.innerHTML = planLayout();
    wrap.appendChild(content);
  };

  bindHandlers() {
    this.toggle.addEventListener(`click`, (ev) => {
      ev.preventDefault();

      this._toggleModal(true);
    });
  };
}

const modalMezzanine = new ModalMezzanine();

export default modalMezzanine;
